import dotSpinner from '../elements/dotSpinner.js';
dotSpinner.register();
